/* eslint-disable import/prefer-default-export */
import Desktop from "../app/Desktop.vue";

import { desktop } from "../router";

export const app = () => {
  return {
    layout: Desktop,
    router: desktop
  };
};
